import { render, staticRenderFns } from "./ReporteDashboard.vue?vue&type=template&id=2d087b96&"
import script from "./ReporteDashboard.vue?vue&type=script&lang=js&"
export * from "./ReporteDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports